/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';

import {Observable} from 'rxjs/Observable';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { AccountService } from '../../services/account.service';
import { CacheService } from '../../global/ng2-cache/services/cache.service';
import { SessionService } from '../../services/session2.service';
import { ErrorService } from '../../services/error.service';
import { GlobalMessageService } from '../../services/global-message.service';
import { DriftService } from '../../services/drift.service';

//import { Animations } from '../../global/animations';
import { ConfirmDialogComponent } from '../../global/confirm-dialog/confirm-dialog.component';
import { AlertDialogComponent } from '../../global/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-settings-domains',
  templateUrl: './settings-domains.component.html'
  // host: { '[@routerTransition]': 'true' },
  // animations: Animations.page
})
export class SettingsDomainsComponent implements OnInit {

  loadingPage: boolean = true;
  addDomainDialogRef: BsModalRef;
  testingDomains: boolean = false;
  testedDomains: any[] = [];
  accountData: any;
  forwardAddress: string;
  replyDomain: string = '';
  forwarding: boolean = false;


  constructor(private accountService: AccountService,
              private cacheService: CacheService,
              private sessionService: SessionService,
              private errorService: ErrorService,
              private driftService: DriftService,
              private modalService: BsModalService,
              private globalMessageService: GlobalMessageService) { }

  ngOnInit() {
    if (!this.cacheService.get('session')) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.initView();
        }
      )
    }
    else {
      this.initView();
    }
  }

  newDomain(dialog) {
    this.addDomainDialogRef = this.modalService.show(dialog, {class: 'modal-md'});
  }

  addDomain() {
    this.addDomainDialogRef.hide();
    this.accountService.addReplyDomain(this.replyDomain).subscribe(
      (result: any) => {
        if (result.result == 'used') {

          this.modalService.show(AlertDialogComponent, Object.assign({}, {
            initialState: {
              message: `The domain ${this.replyDomain} is already in use`,
              confirmBtn: 'Close'
            }
          }));
        }
        else {
          this.accountData.domains.push({ domain: this.replyDomain, verified: false });
          this.globalMessageService.message('Domain was added to your account');
          this.driftService.track('added-domain', { domain: this.replyDomain } );
          this.testDomains();
        }
      },
      err => {
        this.globalMessageService.error();
        this.errorService.log(err, 'settings-domains.component', 'newDomain');
      });
  }

  removeDomain(domain) {

    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Please confirm you would like to remove ${domain.domain} from your account.`,
        confirm: function() {
          me.accountService.removeReplyDomain(domain.domain).subscribe(
            (result: any) => {
              me.globalMessageService.message('Domain was removed from your account');
              me.driftService.track('deleted-domain', { domain: domain.domain } );
              for (var idx = 0; idx < me.accountData.domains.length; idx++) {
                if (me.accountData.domains[idx].domain == domain.domain) {
                  me.accountData.domains.splice(idx, 1);
                  break;
                }
              }
              me.testDomains();
            },
            err => {
              me.globalMessageService.error();
              me.errorService.log(err, 'settings-domains.component', 'removeDomain');
            });
        }
      }
    }));
  }

  testDomains() {
    this.testingDomains = true;
    if (this.accountData.domains.length == 0) {
      this.testedDomains= [];
      this.testingDomains = false;
      return;
    }

    Observable.forkJoin(
      this.accountData.domains.map(
        d => this.accountService.testMX(d.domain).map((res: Observable<any>) => res)
      )
    )
    .subscribe(
      (data: any) => {
        this.testingDomains = false;
        this.testedDomains = data;

        for (var idx=0; idx<this.testedDomains.length; idx++) {
          if (this.testedDomains[idx].records.length == 0) {
            this.testedDomains[idx].valid = false;
          }
          else {
            var highestPriority = 10000;
            var highestPriorityExchange = '';
            for (var i=0; i<this.testedDomains[idx].records.length; i++) {
              if (this.testedDomains[idx].records[i].priority < highestPriority) {
                highestPriority = this.testedDomains[idx].records[i].priority;
                highestPriorityExchange = this.testedDomains[idx].records[i].exchange;
              }
            }
            let found: boolean = false;

            this.testedDomains[idx].mx_config.forEach((mxDomain) => {
              if (highestPriorityExchange == mxDomain) {
                found = true;
              }
            });
            if (found) {
              this.testedDomains[idx].valid = true;
            }
            else {
              this.testedDomains[idx].valid = false;
            }
          }
        }
      },
      err => {
        this.testingDomains = false;
      }
    );
  }

  copyForward() {
    this.globalMessageService.message('Forwarding address copied to your clipboard');
  }

  private initView() {
    this.loadingPage = true;
    const session = this.cacheService.get('session');
    if (session.f) {
      this.forwarding = session.f.forwarding || false;
    }
  this.accountService.getAccount().subscribe(
      (result: any) => {
      this.accountData = result;
      this.forwardAddress = this.accountData.forwards + '@replies.siftrock.com';
      this.loadingPage = false;
      this.testDomains();
    },
    err => {
      this.globalMessageService.error();
      this.errorService.log(err, 'settings-domains.component', 'initView');
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/settings/settings-domains/settings-domains.component.ts